module.exports = __webpack_public_path__ + "img/p2.75a88eea.jpg";